














































































































































































































































import Vue from "vue";
import Toolbar from "../components/toolbar/Toolbar.vue";
import DocumentViewer from "../components/modules/document/DocumentViewer.vue";
import {
    Controllers,
    DocumentTypePrimitive,
    DocumentAnchor,
    InteractiveDocumentContent,
    QueryString,
    IsNotFoundResult,
    IsForbiddenResult,
    AttentionRequired,
    UserMini,
    DocumentContent
} from "@infoland/iprova-api";
import { ReadConfirmation } from "../types/readconfirmation/readconfirmation";
import storeHelper from "../store/store-helper";
import Utils from "../utils";
import * as UAS from "@/userapplicationstate";
import { DocumentField } from "@infoland/iprova-api";
import { CommentType, DocumentReviewState, DocumentRoute, DocumentVersionState, FeatureType, SubscriptionType } from "@/enums";
import { QuickCodeInfo } from "@/types/document/quickCodeInfo";
import { DeviceType, DocumentHitPost } from "@/types/document/documentHitPost";
import Shared from "../shared";
import { Constants } from "../constants";
import { OfficeOnlineParams } from "@/types/OfficeOnlineParams";
import { getDocumentFieldsAsync, getDocumentReviewersAsync } from "@/documents";
import CommentsContainer from "../components/modules/document/comment/CommentsContainer.vue";
import { DocumentResult } from "@/types/document/document";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
import CheckDocumentAction from "@/components/modules/document/toolbar/actions/CheckDocumentAction.vue";
import ApproveDocumentReviewAction from "@/components/modules/document/toolbar/actions/ApproveDocumentReviewAction.vue";
import RejectDocumentReviewAction from "@/components/modules/document/toolbar/actions/RejectDocumentReviewAction.vue";
import MenuDocumentReviewActions from "@/components/modules/document/toolbar/actions/MenuDocumentReviewActions.vue";
import ReadConfirmationAction from "@/components/modules/document/toolbar/actions/ReadConfirmationAction.vue";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import DocumentToolbar from "@/components/modules/document/toolbar/DocumentToolbar.vue";
import { DocumentReviewer } from "@/types/document/documentReviewer";
import DocumentInstructions from "../components/modules/document/DocumentInstructions.vue";

const snackbarTimeOutValue = 10000;

export default Vue.extend({
    name: "Document",
    components: {
        Toolbar,
        DocumentViewer,
        CommentsContainer,
        CheckDocumentAction,
        ApproveDocumentReviewAction,
        RejectDocumentReviewAction,
        MenuDocumentReviewActions,
        DocumentInstructions,
        ZenyaDialog,
        DocumentToolbar,
        ReadConfirmationAction
    },
    props: {
        documentId: String,
        quickCode: String,
        bookmark: String,
        paragraph: Number,
        page: Number,
        versionNumber: Number
    },
    data: function () {
        return {
            documentProperties: null as DocumentVersionInfo,
            changesSincePreviousVersion: null as string,
            commentSubjectSelections: null as DocumentAnchor[],
            commentDialogVisible: false,
            loadDocument: false,
            showMoreChanges: false,
            showPrintDocumentDialog: false,
            documentIdData: this.documentId,
            initializing: true,
            isDialogDisplayed: false,
            documentFields: [] as DocumentField[],
            documentLoadErrorMessage: null,
            changesShown: false,
            constants: { ...Constants.Document },
            documentContent: null as DocumentContent | InteractiveDocumentContent | OfficeOnlineParams,
            documentURL: null as string,
            showCommentDrawer: false,
            commentType: { ...CommentType },
            showChangesComparedToPrevious: true,
            documentVersionInfo: null as DocumentVersionInfo,
            documentRoute: null as DocumentRoute,
            showReviewInstructions: false,
            reviewer: null as DocumentReviewer,
            showReviewInstructionsDialog: false,
            showReadNextDocumentDialog: false,
            snackbarTextIsOverflown: false,
            snackbarTimeOut: snackbarTimeOutValue,
            justClickedShowChanged: false,
            changesReadFromUAS: true,
            suppressInstructions: false,
            showTranslatedVersion: false,
            featureAITranslateEnabled: false
        };
    },
    watch: {
        changedProps: {
            async handler() {
                await this.init();
            },
            immediate: true
        },
        showReviewInstructionsDialog: {
            handler(newValue) {
                //do this only on dialog close
                if (!newValue) Utils.updateReviewRoundDescriptionReadByUser(this.reviewer.round.review_template_round_id, this.suppressInstructions);

                storeHelper.siteStore.setIsDialogDisplayed(this.showReviewInstructionsDialog);
            }
        },
        showReadNextDocumentDialog: function (newValue: boolean) {
            this.isDialogDisplayed = newValue;
        },
        showChangesComparedToPrevious: function (newValue: boolean) {
            if (newValue) this.setSnackbarTimer(this.justClickedShowChanged ? -1 : snackbarTimeOutValue);
        },
        snackbarConditions: function (newValue: string) {
            if (newValue) this.setSnackbarTextIsOverflown();
        }
    },
    computed: {
        snackbarConditions(): boolean {
            return (
                this.showChangesSnackBar &&
                !this.isInternetExplorerBrowser &&
                this.showChangesComparedToPrevious &&
                this.changesSincePreviousVersion != null
            );
        },
        isReviewDocument(): boolean {
            return this.$route.name === "DocumentReview";
        },
        documentCanBeReviewed(): boolean {
            return this.documentProperties?.state === DocumentVersionState.Review;
        },
        isPublishedDocument(): boolean {
            return this.$route.name === "Document" || this.$route.name === "QuickCode";
        },
        documentCanBeChecked(): boolean {
            return (
                this.documentProperties &&
                this.documentProperties.can_check_document &&
                this.documentProperties.attention_required_flags &&
                (this.documentProperties.attention_required_flags.includes(AttentionRequired.check_date_approaches) ||
                    this.documentProperties.attention_required_flags.includes(AttentionRequired.check_date_exceeded))
            );
        },
        isCheckDocument(): boolean {
            return this.$route.name === "CheckDocument";
        },
        isReadDocument(): boolean {
            return this.$route.name === "ReadDocument";
        },
        changedProps(): Object {
            return {
                documentId: this.documentId,
                quickCode: this.quickCode,
                bookmark: this.bookmark,
                paragraph: this.paragraph,
                page: this.page
            };
        },
        isDocumentReady(): Boolean {
            return this.documentProperties != null && !this.initializing && !this.isPreviewMode;
        },
        isQuickCode(): boolean {
            return this.$router.currentRoute.name == "QuickCode";
        },
        isPreviewMode(): boolean {
            return this.$router.currentRoute.name == "PreviewDocument";
        },
        isInternetExplorerBrowser(): boolean {
            return Utils.isIE11;
        },
        showDocumentViewer(): boolean {
            if (
                this.isInternetExplorerBrowser &&
                (this.isDialogDisplayed || (this.$vuetify.breakpoint.smAndDown && this.showCommentDrawer) || storeHelper.siteStore.isDialogDisplayed)
            ) {
                return false;
            }
            if (this.$refs.documentViewer) {
                (this.$refs.documentViewer as Vue & { onResize: () => void }).onResize();
            }
            return true;
        },
        getChangesButtonLabel(): string {
            if (this.showMoreChanges) {
                return this.$t("document.showLessButton").toString();
            } else {
                return this.$t("document.showMoreButton").toString();
            }
        },
        showSnackBarMessage(): boolean {
            let show: boolean =
                !this.changesReadFromUAS &&
                storeHelper.siteStore.snackBarMessage &&
                storeHelper.siteStore.snackBarMessage.text == null &&
                (this.$vuetify.breakpoint.mdAndUp || !this.isDialogDisplayed);

            return show;
        },
        canReadDocument(): boolean {
            return this.documentProperties != null && (this.documentProperties.can_download_binary || this.documentProperties.can_download_content);
        },
        showFooter(): boolean {
            return (
                !this.$vuetify.breakpoint.mdAndUp &&
                this.canReadDocument &&
                this.documentProperties &&
                this.documentProperties.type != DocumentTypePrimitive.interactive
            );
        },
        isInteractiveDocument(): boolean {
            if (this.documentProperties)
                return (
                    this.documentProperties.type == DocumentTypePrimitive.interactive ||
                    (this.documentProperties.type == DocumentTypePrimitive.web_share &&
                        this.documentProperties.original_type == DocumentTypePrimitive.interactive)
                );
            else return false;
        },
        isStructuredDocument(): boolean {
            if (this.documentProperties) return this.documentProperties.type == DocumentTypePrimitive.structured_document;
            else return false;
        },
        isFreeWebDocument(): boolean {
            if (this.documentProperties) return this.documentProperties.type == DocumentTypePrimitive.free_web;
            else return false;
        },
        documentVersion(): number {
            if (this.documentProperties) {
                return this.documentProperties.version;
            } else {
                return null;
            }
        },
        actionBarWidth(): number {
            if (this.showFooter) {
                return 0;
            }
            if (this.$vuetify.breakpoint.lgAndUp) {
                return 400;
            } else {
                return 300;
            }
        },
        documentTitle(): string {
            if (this.documentProperties != null) {
                return (
                    this.documentProperties.title + " (" + this.$t("general.labels.version").toString() + " " + this.documentProperties.version + ")"
                );
            } else {
                return this.$t("document.title").toString();
            }
        },
        showChangesSnackBar(): boolean {
            return this.changesSincePreviousVersion != null && this.showSnackBarMessage;
        },
        isInteractiveOrStructuredDocument(): boolean {
            return this.isInteractiveDocument || this.isStructuredDocument;
        },
        smAndDown(): boolean {
            return this.$vuetify.breakpoint.smAndDown;
        },
        lgAndUp(): boolean {
            return this.$vuetify.breakpoint.lgAndUp;
        },
        shouldShowCommentsDrawer(): boolean {
            // comments drawer should be shown for check or review
            if (this.documentCanBeChecked && this.isCheckDocument) {
                return true;
            }
            if (this.isReviewDocument && this.documentCanBeReviewed) {
                return true;
            }
            return false;
        },
        oldViewerUrl(): String {
            if (this.documentProperties) {
                if (this.isReviewDocument) {
                    return Shared.GetAuthenticatedUrl(
                        `${Shared.iProvaUrl}/iDocument/?DocumentID=${this.documentProperties.document_id}&document_version=${this.documentProperties.version}&SubscriptionType=${SubscriptionType.Review}`
                    );
                }
                if (this.isPreviewMode) {
                    return Shared.GetAuthenticatedUrl(
                        `${Shared.iProvaUrl}/iDocument/?DocumentID=${this.documentProperties.document_id}&document_version=${this.documentProperties.version}&Preview=true`
                    );
                }
                let query: string[];
                if (this.$route?.query) {
                    query = Object.keys(this.$route.query).map(qsKey => {
                        return `${qsKey}=${encodeURIComponent(this.$route.query[qsKey] as string)}`;
                    });
                }
                return Shared.GetAuthenticatedUrl(
                    `${Shared.iProvaUrl}/iDocument/?DocumentID=${this.documentProperties.document_id}${query != null ? "&" + query.join("&") : ""}`
                );
            }
            return null;
        },
        userIsDocumentWriter(): boolean {
            const adminUser = this.documentVersionInfo?.writers_group?.find(da => da.user_id === this.$user.user_id);
            if (adminUser) {
                return true;
            }
            return false;
        },
        userIsDocumentAdministrator(): boolean {
            const adminUser = this.documentVersionInfo?.document_administrators?.find(da => da.user_id === this.$user.user_id);
            if (adminUser) {
                return true;
            }
            return false;
        },
        documentAdministrators(): UserMini[] {
            if (this.documentVersionInfo) {
                return this.documentVersionInfo.document_administrators;
            }
            return [];
        },
        commenterTypeForAddingComment(): CommentType {
            return this.documentCanBeChecked && this.isCheckDocument && this.userIsDocumentAdministrator
                ? CommentType.Writer
                : this.isReviewDocument && this.documentCanBeReviewed
                ? CommentType.Reviewer
                : CommentType.Reader;
        },
        hasReviewInstructions(): boolean {
            if (this.reviewer?.round?.instruction) {
                return true;
            } else {
                return false;
            }
        },
        readConfirmationId(): number {
            let readList: ReadConfirmation[] = storeHelper.readListStore.list;

            if (readList != null)
                return (readList.find(x => x.document.document_id == this.documentProperties.document_id) || {}).read_confirmation_id || null;
            else return null;
        },
        displayTranslateButton(): boolean {
            if (
                this.isInteractiveDocument &&
                this.isPublishedDocument &&
                this.featureAITranslateEnabled &&
                this.documentProperties.language != this.$user.language
            ) {
                return true;
            }
            return false;
        }
    },
    methods: {
        getChangesText(): string {
            return (this.$t("document.changesPreviousVersionTitle") as string) + this.changesSincePreviousVersion;
        },
        showChangesComparedToPreviousClicked() {
            this.justClickedShowChanged = true;
            this.changesReadFromUAS = false; // once this show changes button has been clicked showing the changes no longer depends on value in UAS
            this.showChangesComparedToPrevious = true;
            this.clickChangesButton(true);
        },
        setSnackbarTimer(value: number) {
            this.snackbarTimeOut = value;
        },
        setSnackbarTextIsOverflown(): void {
            this.$nextTick(() => {
                let snackBarElement: HTMLElement = this.$refs.snackbarText as HTMLElement;
                this.snackbarTextIsOverflown =
                    (snackBarElement && snackBarElement.scrollWidth > snackBarElement.clientWidth) ||
                    (snackBarElement && snackBarElement.scrollHeight > snackBarElement.clientHeight);

                if (!this.snackbarTextIsOverflown && !this.isReviewDocument)
                    UAS.set("documentversionchangesread_" + this.documentProperties.document_id + "_" + this.documentProperties.version, "1");
            });
        },
        onSuppressChanged(value: boolean): void {
            this.suppressInstructions = value;
        },
        async loadDocumentAsync(): Promise<DocumentResult> {
            if (this.isReviewDocument) {
                return await storeHelper.documentStore.loadDocumentByStateAsync(this.documentIdData, DocumentVersionState.Review, true);
            } else if (this.isPreviewMode) {
                return await storeHelper.documentStore.loadDocumentByVersionAsync(this.documentIdData, this.versionNumber);
            }
            return await storeHelper.documentStore.loadDocumentByStateAsync(this.documentIdData, DocumentVersionState.Published, true);
        },
        async getDocumentContentAsync(rawContent?: QueryString): Promise<DocumentContent | InteractiveDocumentContent | null> {
            let state = DocumentVersionState.Published;
            if (this.isReviewDocument) {
                state = DocumentVersionState.Review;
                this.showTranslatedVersion = false;
            } else if (this.isPreviewMode) {
                this.showTranslatedVersion = false;
                return await storeHelper.documentStore.getDocumentContentByVersionAsync(
                    this.documentProperties.document_id,
                    this.documentProperties.version,
                    rawContent
                );
            }
            if (
                this.isInteractiveDocument &&
                this.isPublishedDocument &&
                (await this.getDocumentAiTranslateEnabledAsync()) &&
                this.showTranslatedVersion &&
                this.documentProperties.language != this.$user.language
            ) {
                try {
                    let interactiveDocumentContent = (await storeHelper.documentStore.getIluminusDocumentContentAsync(
                        this.documentProperties.document_id,
                        this.$user.language
                    )) as InteractiveDocumentContent;

                    if (!interactiveDocumentContent || typeof interactiveDocumentContent.content === "undefined") {
                        throw new Error("Invalid data returned: Expected InteractiveDocumentContent.");
                    }

                    return interactiveDocumentContent;
                } catch (error) {
                    this.showTranslatedVersion = false;
                    storeHelper.siteStore.setSnackBarMessage(this.$t("document.translationError") as string, true);
                    return await storeHelper.documentStore.getDocumentContentByStateAsync(this.documentProperties.document_id, state, rawContent);
                }
            } else {
                this.showTranslatedVersion = false;
                return await storeHelper.documentStore.getDocumentContentByStateAsync(this.documentProperties.document_id, state, rawContent);
            }
        },
        getDocumentURL(): string {
            let docUrl: string = null;
            if (this.documentProperties.type == DocumentTypePrimitive.web_share && this.documentProperties.mime_type == "application/pdf") {
                //use document resource loader instead of api/download to hyperlinks in PDF resolve correctly to WebShareHyperlinkLoader.ashx (fix DF-66889)
                docUrl = `${Shared.iProvaUrl}/iDocument/viewers/webshare/DocumentResource/${this.documentProperties.document_id}/${this.documentProperties.state}/Document.pdf`;
            } else if (this.isReviewDocument) {
                docUrl = `${Shared.iProvaApiUrl}/documents/${this.documentProperties.document_id}/review/download`;
            } else if (this.isPreviewMode) {
                docUrl = `${Shared.iProvaApiUrl}/documents/${this.documentProperties.document_id}/v${this.documentProperties.version}/download`;
            } else {
                docUrl = `${Shared.iProvaApiUrl}/documents/${this.documentProperties.document_id}/download`;
            }
            return Shared.GetAuthenticatedUrl(docUrl);
        },
        async init(): Promise<void> {
            if (this.isReviewDocument && Utils.isAdministrator(this.$user.user_id)) {
                document.title = Utils.getPageTitle(`${this.$t("document.noPermissions").toString().replace(".", "")}`, "before");
                this.documentLoadErrorMessage = this.$t("document.noPermissions").toString();
                return;
            }
            if (this.isCheckDocument) {
                this.documentRoute = DocumentRoute.CheckDocument;
            } else if (this.isReviewDocument) {
                this.documentRoute = DocumentRoute.ReviewDocument;
            } else if (this.isReadDocument) {
                this.documentRoute = DocumentRoute.ReadDocument;
            } else {
                this.documentRoute = DocumentRoute.PublishedDocument;
            }
            this.documentProperties = null;
            this.changesSincePreviousVersion = null;
            this.commentSubjectSelections = null;
            this.commentDialogVisible = false;
            this.loadDocument = false;
            this.showMoreChanges = false;
            this.showPrintDocumentDialog = false;
            this.documentIdData = this.documentId;
            this.initializing = true;
            this.isDialogDisplayed = false;
            this.documentFields = [];
            this.documentLoadErrorMessage = null;
            this.documentContent = null;
            this.reviewer = null;
            this.showReviewInstructionsDialog = false;
            this.showChangesComparedToPrevious = true;

            if (this.isQuickCode) {
                let quickCodeInfo: QuickCodeInfo = await Controllers.GenericController.getAsync<QuickCodeInfo>(`/quick_codes/${this.quickCode}`);
                if (this.quickCode != null) {
                    this.documentIdData = quickCodeInfo.document_id;
                }
            }
            if (this.documentIdData) {
                //load document
                let response: DocumentResult = await this.loadDocumentAsync();
                if (response) {
                    if (response.documentInfo) {
                        if (!response.documentInfo.active && !this.isReviewDocument) {
                            if (this.isCheckDocument) {
                                document.title = Utils.getPageTitle(this.$t("document.noActiveVersionToCheck").toString().replace(".", ""), "before");
                                this.documentLoadErrorMessage = this.$t("document.noActiveVersionToCheck");
                            } else {
                                document.title = Utils.getPageTitle(
                                    `${this.$t("document.documentInactive", { documentName: this.documentTitle }).toString().replace(".", "")}`,
                                    "before"
                                );
                                this.documentLoadErrorMessage = this.$t("document.documentInactive", {
                                    documentName: this.documentTitle
                                }).toString();
                            }
                        } else {
                            if (response.documentInfo.state === DocumentVersionState.Published && !this.isPreviewMode) {
                                // call log hit
                                Controllers.GenericController.postAsync(`documents/${this.documentIdData}/hits`, {
                                    device_type: Utils.isMobile() ? DeviceType.Mobile : DeviceType.Desktop
                                } as DocumentHitPost);

                                //  load read list if list isn't loaded yet
                                if (storeHelper.readListStore.list == null) await storeHelper.readListStore.loadListAsync();
                            }

                            if (this.isReviewDocument) {
                                this.reviewer = (
                                    await getDocumentReviewersAsync(
                                        response.documentInfo.document_id,
                                        response.documentInfo.version,
                                        [this.$user.user_id],
                                        true,
                                        true
                                    )
                                )[0];
                                if (this.reviewer) {
                                    if (this.reviewer.state === DocumentReviewState.not_started) {
                                        if (this.reviewer.round?.instruction && this.reviewer.round?.show_instruction_for_current_user) {
                                            this.showReviewInstructionsDialog = true;
                                        }
                                    } else {
                                        this.documentLoadErrorMessage = this.$t("document.noReviewAllowed").toString();
                                        return;
                                    }
                                } else {
                                    this.documentLoadErrorMessage = this.$t("document.noReviewAllowed").toString();
                                    return;
                                }
                            }

                            this.documentProperties = response.documentInfo;
                            //load document fields
                            await this.getDocumentFieldsAsync();
                            this.changesReadFromUAS =
                                (await UAS.get(
                                    "documentversionchangesread_" + response.documentInfo.document_id + "_" + response.documentInfo.version
                                )) == "1";
                            if (this.changesReadFromUAS) this.showChangesComparedToPrevious = false;

                            //load document content
                            if (this.documentProperties.show_in_office_online_viewer) {
                                this.documentContent = (await storeHelper.documentStore.getEmbeddedViewAsync(
                                    this.documentProperties.document_id,
                                    this.documentProperties.version
                                )) as OfficeOnlineParams;
                            } else if (this.documentProperties.can_download_content) {
                                if (this.isInteractiveDocument) {
                                    //iLuminus document
                                    //load iLuminus document content
                                    this.showTranslatedVersion = true;
                                    this.documentContent = (await this.getDocumentContentAsync({
                                        rawContent: "true"
                                    } as QueryString)) as InteractiveDocumentContent;
                                } else {
                                    //load document content
                                    this.documentContent = (await this.getDocumentContentAsync()) as DocumentContent;
                                }
                            } else if (this.documentProperties.can_download_binary) {
                                this.documentURL = this.getDocumentURL();
                            }

                            if (this.shouldShowCommentsDrawer) {
                                await storeHelper.documentStore.getDocumentCommentsAsync(this.documentIdData, this.documentProperties.state);
                            }
                            if (this.documentCanBeChecked && this.isCheckDocument) {
                                this.documentVersionInfo = await storeHelper.documentStore.loadDocumentVersionIncludingSpecificUsersAsync(
                                    this.documentId,
                                    this.documentVersion,
                                    true,
                                    true,
                                    true,
                                    true,
                                    false,
                                    true
                                );
                            }
                            this.loadDocument = true;
                        }
                    } else if (IsNotFoundResult(response.problemResult)) {
                        if (Utils.isAnonymousUser(this.$user.user_id)) {
                            // redirect to login page, cause for anonymous 'NotFound' might actually be 'Forbidden'
                            Utils.navigateToLogin(window.location.href);
                        } else if (this.isPublishedDocument) {
                            document.title = Utils.getPageTitle(`${this.$t("document.noPublishedVersion").toString().replace(".", "")}`, "before");
                            this.documentLoadErrorMessage = this.$t("document.noPublishedVersion").toString();
                        } else if (this.isReviewDocument) {
                            this.documentLoadErrorMessage = this.$t("document.noReviewAllowed").toString();
                        } else {
                            document.title = Utils.getPageTitle(`${this.$t("document.notFound").toString().replace(".", "")}`, "before");
                            this.documentLoadErrorMessage = this.$t("document.notFound").toString();
                        }
                    } else if (IsForbiddenResult(response.problemResult)) {
                        if (Utils.isAnonymousUser(this.$user.user_id)) {
                            Utils.navigateToLogin(window.location.href);
                        } else {
                            if (this.isReviewDocument) {
                                this.documentLoadErrorMessage = this.$t("document.noReviewAllowed").toString();
                            } else {
                                document.title = Utils.getPageTitle(`${this.$t("document.noPermissions").toString().replace(".", "")}`, "before");
                                this.documentLoadErrorMessage = this.$t("document.noPermissions").toString();
                            }
                        }
                    } else {
                        document.title = Utils.getPageTitle(`${this.$t("document.loadError").toString().replace(".", "")}`, "before");
                        this.documentLoadErrorMessage = this.$t("document.loadError").toString();
                    }
                } else {
                    document.title = Utils.getPageTitle(`${this.$t("document.noAvailableVersion").toString().replace(".", "")}`, "before");
                    this.documentLoadErrorMessage = this.$t("document.noAvailableVersion").toString();
                }
            }
        },
        setCommentSubject(subjects: DocumentAnchor[]) {
            this.commentSubjectSelections = subjects;
        },
        setInitializing(initializing: boolean) {
            this.initializing = initializing;
        },
        followHyperlink(hyperlinkInfo) {
            if (hyperlinkInfo.id) {
                if (hyperlinkInfo.id.startsWith("http://") || hyperlinkInfo.id.startsWith("https://")) {
                    window.open(hyperlinkInfo.id, "_blank");
                    return;
                }

                const url = Shared.iProvaUrl + "/management/hyperlinkloader.aspx?hyperlinkid=" + hyperlinkInfo.id;
                if (hyperlinkInfo.openInNewTab) window.open(url, "_blank");
                else location.href = url;
            }
        },
        clickChangesButton(value: boolean) {
            this.changesShown = true;
            this.showMoreChanges = value;
            this.setSnackbarTimer(this.showMoreChanges ? -1 : snackbarTimeOutValue);
            if (value && !this.isReviewDocument)
                UAS.set("documentversionchangesread_" + this.documentProperties.document_id + "_" + this.documentProperties.version, "1");
        },
        setIsDialogDisplayed(isDisplayed: boolean) {
            this.isDialogDisplayed = isDisplayed;
        },
        scrollToAnchor(anchorId: string): void {
            (this.$refs.documentViewer as Vue & { scrollToAnchor: (anchorId: string) => void }).scrollToAnchor(anchorId);
        },
        async getDocumentFieldsAsync(): Promise<void> {
            let state = DocumentVersionState.Published;
            if (this.isReviewDocument) {
                state = DocumentVersionState.Review;
            } else if (this.isPreviewMode) {
                state = this.documentProperties.state;
            }
            const result = await getDocumentFieldsAsync(this.documentIdData, state, true, true);

            //there is a scenario when you are receiving forbidden. this is checking against it
            if (result && result.length) {
                this.documentFields = result.filter(
                    field => field.values.length > 0 && !(field.values[0].value === undefined || field.values[0].value == "")
                );
                for (let item of this.documentFields) {
                    if (item.field_id == Constants.Document.DocumentFieldId.ChangesComparedToPreviousVersion) {
                        this.changesSincePreviousVersion = item.values[0].value;
                    }
                }
            }
        },
        async changeInteractiveDocumentContentAsync(showOriginalVersion: boolean): Promise<void> {
            this.loadDocument = false;
            this.initializing = true;
            this.showTranslatedVersion = !showOriginalVersion;
            this.documentContent = (await this.getDocumentContentAsync({
                rawContent: "true"
            } as QueryString)) as InteractiveDocumentContent;
            this.loadDocument = true;
        },
        async getDocumentAiTranslateEnabledAsync(): Promise<boolean> {
            var feature = await storeHelper.FeaturesStore.featureByType(FeatureType.doc_ai_translate);
            this.featureAITranslateEnabled = feature?.enabled ?? false;
            return this.featureAITranslateEnabled;
        }
    }
});
